import { IPatientRegistry, IPatientRepository, IPatientProfileRepository } from "../../../domain/patient";
import { PatientRepository, PatientProfileRepository } from ".";

export class PatientRegistry implements IPatientRegistry {
  constructor(private _getToken: () => string) {
  }

  getPatientRepository(): IPatientRepository {
    return new PatientRepository(this._getToken);
  }

  getPatientProfileRepository(): IPatientProfileRepository {
    return new PatientProfileRepository(this._getToken);
  }
}
